import React from 'react';
import { Breadcrumb, BreadcrumbProps } from '../../components/breadcrumb/Breadcrumb';
import { CategoryBanner, CategoryBannerProps } from '../../components/category-banner/CategoryBanner';
import { CategoryProducts } from '../../components/category-products/CategoryProducts';
import { PopularProducts } from '../../components/popular-products/PopularProducts';
import { SubCategories } from '../../components/sub-categories/SubCategories';
import { ImageModel, LinkModel, ProductTileModel } from '../../models/globals';

interface SubCategoryTileModel {
    name: string;
    url: string;
    image: ImageModel;
    defaultImage: ImageModel;
}

interface CategoryProps {
    breadcrumb: BreadcrumbProps;
    careerProducts: ProductTileModel[];
    careerSearchLink: LinkModel;
    categoryBanner: CategoryBannerProps;
    fundamentalsProducts: ProductTileModel[];
    fundamentalsSearchLink: LinkModel;
    popularProducts: ProductTileModel[];
    subCategories: SubCategoryTileModel[];
}

const Category: React.FC<CategoryProps> = ({
    breadcrumb,
    categoryBanner,
    careerProducts,
    careerSearchLink,
    fundamentalsProducts,
    fundamentalsSearchLink,
    popularProducts,
    subCategories,
}) => {
    return (
        <>
            <Breadcrumb {...breadcrumb} />
            <CategoryBanner {...categoryBanner} />
            <SubCategories subCategories={subCategories} />
            <PopularProducts popularProducts={popularProducts} headerTitle="Most Popular Courses" />
            <CategoryProducts
                careerProducts={careerProducts}
                careerSearchLink={careerSearchLink}
                categoryBanner={categoryBanner}
                fundamentalsProducts={fundamentalsProducts}
                fundamentalsSearchLink={fundamentalsSearchLink}
            />
        </>
    );
};

export { Category, CategoryProps };
